import React from 'react';

import {FieldLastEditStamp} from '../FieldLastEditStamp';
import {TaskFieldSubmitButton} from '../TaskFieldSubmitButton';

import type {StepTaskFieldProps} from '../commonprops';

export const StepTaskTextField = ({
  field,
  onSubmit,
  inputValueChanged,
  isSaving,
  progress,
  value,
  initial,
  blocked,
}: StepTaskFieldProps) => (
  <div className="form-group row mb-0">
    {field.label !== '' ? (
      <label
        htmlFor={`step-field-${field.id}`}
        className="col-12 col-form-label pt-0"
      >
        {field.label}
      </label>
    ) : null}

    <form
      className="col-12"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <div className="input-group">
        <input
          id={`step-field-${field.id}`}
          className="form-control"
          type="text"
          value={value}
          onBlur={(event) => {
            if (event.target.value !== value) {
              return inputValueChanged(event);
            } else {
              onSubmit();
            }
          }}
          onChange={inputValueChanged}
          disabled={blocked}
        />
        <TaskFieldSubmitButton
          progress={progress}
          isSaving={isSaving}
          value={value}
          initial={initial}
          blocked={blocked}
          onSubmit={onSubmit}
        />
      </div>
      <FieldLastEditStamp progress={progress} />
    </form>
  </div>
);
